export default "__VITE_ASSET__0aa16a25__"